import { disableScroll } from "../functions/disable-scroll.js";
import { enableScroll } from "../functions/enable-scroll.js";

//!TODO replace gsap to css classes
export default function initReservationsPopup() {
  document.addEventListener("DOMContentLoaded", () => {
    const btns = document.querySelectorAll(".reservations-btn");
    const closePopup = document.querySelector(".reservations-popup__close");
    btns.forEach((btn) => {
      btn.addEventListener("click", () => {
        console.log("openpopup");
        gsap.to(".reservations-popup", {
          display: "flex",
          opacity: 0,
          onComplete: () => {
            gsap.to(".reservations-popup", { opacity: 1 });
          },
        });

        document.addEventListener("keypress", (e) => {
          console.log(e.key);
          if (e.key === "Escape") {
            console.log("closepopup");
            gsap.to(".reservations-popup", {
              display: "flex",
              opacity: 0,
              onComplete: () => {
                gsap.to(".reservations-popup", { display: "none" });
              },
            });
          }
        });

        closePopup.addEventListener("click", (e) => {
          gsap.to(".reservations-popup", {
            display: "flex",
            opacity: 0,
            onComplete: () => {
              gsap.to(".reservations-popup", { display: "none" });
            },
          });
        });
      });
    });
  });
}
